require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./relazioni-e-conferenze-conferenza-di-esempio-non-toccare.json") })
        }
      }, "path---relazioni-e-conferenze-conferenza-di-esempio-non-toccare");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---relazioni-e-conferenze-conferenza-di-esempio-non-toccare!./.cache/json/relazioni-e-conferenze-conferenza-di-esempio-non-toccare.json
// module id = 696
// module chunks = 231608221292675